import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";

const CheckboxField = ({ label, checked, onChange }) => {
  return (
    <label
      onClick={() => onChange(!checked)}
      className="flex items-center gap-1.5 cursor-pointer group select-none"
    >
      {checked ? (
        <MdCheckBox className="w-5 h-5 text-primary" />
      ) : (
        <MdCheckBoxOutlineBlank className="w-5 h-5 text-border group-hover:text-text-secondary" />
      )}
      <span className="text-xs text-text-secondary">{label}</span>
    </label>
  );
};
export default CheckboxField;
